import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Globe } from "lucide-react";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password, confirm_password: confirmPassword });
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-8">
        <Link to="/" className="flex items-center gap-2 text-lg font-bold text-slate-900 mb-8">
          <Globe className="w-5 h-5" />
          LCS International
        </Link>
        <h2 data-testid="reset-heading" className="text-2xl font-bold text-slate-900 mb-6">
          Nouveau mot de passe
        </h2>

        {!token && (
          <div data-testid="reset-no-token" className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
            Lien de réinitialisation invalide.
          </div>
        )}
        {error && (
          <div data-testid="reset-error" className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            data-testid="reset-password-input"
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
            placeholder="Nouveau mot de passe"
          />
          <input
            data-testid="reset-confirm-input"
            type="password"
            required
            minLength={8}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent"
            placeholder="Confirmer le mot de passe"
          />
          <button
            data-testid="reset-submit-button"
            type="submit"
            disabled={submitting || !token}
            className="w-full bg-slate-900 text-white font-medium rounded-lg px-4 py-3 hover:bg-slate-700 transition-colors duration-200 disabled:opacity-50"
          >
            {submitting ? "Réinitialisation…" : "Réinitialiser"}
          </button>
        </form>
      </div>
    </div>
  );
}
